import { useEffect } from "react";
import { SITE_NAME, setNavigationTitle } from "../analytics";

/**
 * Publish a page-specific section title that overrides the path-derived
 * base title for both the browser tab and the GA4 `page_view` event.
 *
 * Pass `null` or `undefined` while data is loading; the hook will no-op
 * and the base title set by `AnalyticsRouteTracker` remains in place.
 * Once the page has resolved its content, pass a section string like
 * `"Evento — Liga Pinheiros"` and the hook will append ` · Liga Legacy`,
 * update `document.title`, and flush the buffered page_view to GA with
 * the rich title (provided the call lands within the buffer window).
 *
 * Hooks rules apply: call this unconditionally near the top of the
 * component, before any early returns.
 */
export function usePageTitle(sectionTitle: string | null | undefined): void {
  useEffect(() => {
    if (!sectionTitle) return;
    setNavigationTitle(`${sectionTitle} · ${SITE_NAME}`);
  }, [sectionTitle]);
}
